/**
 * Working hours time options for shift management.
 * Extracted to avoid circular dependencies between firebase.ts and screen files.
 */

export interface WorkingHourOption {
  text: string
  value: number
  id: string
}

export const WORKING_HOURS: WorkingHourOption[] = [
  { text: '00:00', value: 0, id: '0' },
  { text: '00:30', value: 0.5, id: '0.5' },
  { text: '01:00', value: 1, id: '1' },
  { text: '01:30', value: 1.5, id: '1.5' },
  { text: '02:00', value: 2, id: '2' },
  { text: '02:30', value: 2.5, id: '2.5' },
  { text: '03:00', value: 3, id: '3' },
  { text: '03:30', value: 3.5, id: '3.5' },
  { text: '04:00', value: 4, id: '4' },
  { text: '04:30', value: 4.5, id: '4.5' },
  { text: '05:00', value: 5, id: '5' },
  { text: '05:30', value: 5.5, id: '5.5' },
  { text: '06:00', value: 6, id: '6' },
  { text: '06:30', value: 6.5, id: '6.5' },
  { text: '07:00', value: 7, id: '7' },
  { text: '07:30', value: 7.5, id: '7.5' },
  { text: '08:00', value: 8, id: '8' },
  { text: '08:30', value: 8.5, id: '8.5' },
  { text: '09:00', value: 9, id: '9' },
  { text: '09:30', value: 9.5, id: '9.5' },
  { text: '10:00', value: 10, id: '10' },
  { text: '10:30', value: 10.5, id: '10.5' },
  { text: '11:00', value: 11, id: '11' },
  { text: '11:30', value: 11.5, id: '11.5' },
  { text: '12:00', value: 12, id: '12' },
  { text: '12:30', value: 12.5, id: '12.5' },
  { text: '13:00', value: 13, id: '13' },
  { text: '13:30', value: 13.5, id: '13.5' },
  { text: '14:00', value: 14, id: '14' },
  { text: '14:30', value: 14.5, id: '14.5' },
  { text: '15:00', value: 15, id: '15' },
  { text: '15:30', value: 15.5, id: '15.5' },
  { text: '16:00', value: 16, id: '16' },
  { text: '16:30', value: 16.5, id: '16.5' },
  { text: '17:00', value: 17, id: '17' },
  { text: '17:30', value: 17.5, id: '17.5' },
  { text: '18:00', value: 18, id: '18' },
  { text: '18:30', value: 18.5, id: '18.5' },
  { text: '19:00', value: 19, id: '19' },
  { text: '19:30', value: 19.5, id: '19.5' },
  { text: '20:00', value: 20, id: '20' },
  { text: '20:30', value: 20.5, id: '20.5' },
  { text: '21:00', value: 21, id: '21' },
  { text: '21:30', value: 21.5, id: '21.5' },
  { text: '22:00', value: 22, id: '22' },
  { text: '22:30', value: 22.5, id: '22.5' },
  { text: '23:00', value: 23, id: '23' },
  { text: '23:30', value: 23.5, id: '23.5' },
]
